import React from 'react';
import { twMerge } from 'tailwind-merge';

interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  label: string;
  className?: string;
}

const Button: React.FC<Props> = ({ label, className, ...props }) => {
  const baseClass =
    'px-3 py-2 text-sm text-white leading-4 font-bold bg-lsGray-700 rounded-full hover:opacity-50';
  const mergedClass = twMerge(baseClass, className);
  return (
    <button {...props} className={mergedClass}>
      {label}
    </button>
  );
};

Button.displayName = 'Button';

export default Button;
